export default function PageJsonLd() {
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Тренинг по продажам B2B для компаний',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      description: 'Бизнес-тренер и консультант с более чем 18-летним опытом в B2B продажах и переговорах',
      url: 'https://sivko.by/',
    },
    description: 'Корпоративный тренинг по B2B продажам для компаний. Обучение сложным продажам, переговорам, работе с ЛПР, длинному циклу сделки и увеличению конверсии. Беларусь, Россия, Казахстан.',
    areaServed: ['Беларусь', 'Россия', 'Казахстан', 'Израиль'],
    serviceType: 'Корпоративное обучение B2B продажам',
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      category: 'Корпоративный тренинг',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Чем B2B продажи отличаются от B2C?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'В B2B цикл сделки длиннее, участвует несколько лиц принимающих решение, решение принимается рационально, а не эмоционально. Работают закупочные процедуры, тендеры, согласования. Важны отношения, доверие и способность влиять на процесс принятия решения на разных уровнях организации клиента.',
        },
      },
      {
        '@type': 'Question',
        name: 'Сколько длится обучение?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Форматы варьируются: интенсивный тренинг — 1–2 полных дня, модульная программа — от 2 недель до 3 месяцев, комплексная программа с сопровождением — 3–12 месяцев. Точная продолжительность определяется после диагностики текущего уровня команды и поставленных бизнес-целей.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли обучить опытных менеджеров?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да. Опытные менеджеры часто работают «по наитию» и не осознают системных ошибок. Тренинг помогает структурировать их опыт, добавить недостающие инструменты и вывести продажи на новый уровень. Практика на реальных сделках компании делает обучение релевантным для любого уровня.',
        },
      },
      {
        '@type': 'Question',
        name: 'Подходит ли программа производственным компаниям?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, более половины наших проектов — производственные и промышленные компании. Мы работаем со сложными продуктами, длинным циклом сделки, тендерными процедурами и многоуровневыми закупками. Программа адаптируется под специфику отрасли.',
        },
      },
      {
        '@type': 'Question',
        name: 'Работаете ли вы с экспортными продажами?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да. Мы работаем с компаниями из Беларуси, России и Казахстана, которые выходят на международные рынки. Обучаем кросс-культурным переговорам, работе с иностранными закупщиками и адаптации стратегии продаж под специфику разных стран.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли провести обучение онлайн?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, тренинг полностью доступен в онлайн-формате: живые сессии с отработкой диалогов через видеосвязь, ролевые переговоры, детальный разбор реальных записей встреч и звонков. Онлайн-формат полностью сохраняет практическую направленность программы.',
        },
      },
      {
        '@type': 'Question',
        name: 'Есть ли сопровождение после тренинга?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, посттренинговое сопровождение — ключевой элемент нашей методологии. Мы разбираем новые переговоры, поддерживаем участников в Telegram, помогаем внедрять стандарты. Именно сопровождение превращает тренинг из «мероприятия» в устойчивый рост результатов.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли адаптировать программу под нашу специфику?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Каждая программа разрабатывается индивидуально после диагностики. Мы изучаем ваш продукт, рынок, цикл сделки, конкурентов, текущий уровень менеджеров. Ни одной шаблонной программы — только то, что работает в вашей нише.',
        },
      },
      {
        '@type': 'Question',
        name: 'Что делать, если цикл сделки 6 месяцев?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Для длинных сделок мы строим систему управления воронкой: карта ЛПР, стратегия influence, промежуточные KPI, follow-up система, прогнозирование. Менеджеры учатся вести сделку месяцами, не теряя контроль и не «сливая» её на финальном этапе.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли разобрать реальные сделки компании?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Это основа нашей методологии. Мы разбираем текущие сделки участников прямо на тренинге: анализируем карту ЛПР, стратегию переговоров, ошибки в аргументации. Это в десятки раз эффективнее абстрактных кейсов из учебников.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли обучить КАМов и менеджеров по работе с ключевыми клиентами?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, программа включает модуль по работе с ключевыми клиентами: развитие отношений, выявление потенциала, cross-sale и up-sale, удержание и лояльность. КАМы учатся стратегическому управлению портфелем клиентов.',
        },
      },
      {
        '@type': 'Question',
        name: 'Когда появляются первые результаты?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Первые изменения в качестве переговоров заметны уже во время тренинга — на 2-й день участники иначе готовятся к встречам и ведут диалог. Измеримый рост конверсии обычно проявляется через 1–2 месяца при условии посттренингового сопровождения и внедрения стандартов.',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Главная',
        item: { '@id': 'https://business-training.by/', name: 'Главная' },
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Продажи и переговоры',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham', name: 'Продажи и переговоры' },
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Тренинг по продажам B2B для компаний',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham-b2b', name: 'Тренинг по продажам B2B для компаний' },
      },
    ],
  };

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Алексей Сивко',
    description: 'Бизнес-тренер и консультант с более чем 18-летним опытом в B2B продажах и переговорах. Более 100 корпоративных проектов, 450 тренингов, 4500 участников. Практикующий консультант.',
    url: 'https://sivko.by/',
    jobTitle: 'Бизнес-тренер, консультант по продажам',
    worksFor: {
      '@type': 'Organization',
      name: 'BusinessTraining.by',
      url: 'https://business-training.by/',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Минск',
      addressCountry: 'Беларусь',
    },
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(personSchema) }} />
    </>
  );
}